import { combineReducers } from '@reduxjs/toolkit';
import userSlices from './userSlices';
import notificationSlice from './notificationSlice';
import formDataSlice from './formDataSlice';
import reportsSlice from './reportsSlice';
import reportingSlice from './reportingSlice';
import navigationSlice from './navigationSlice';
import mfaSlice from './mfaSlice';
import aiReportsSlice from './aiReportsSlice';
import aiReportHistorySlice from './aiReportHistorySlice';
import institutionSlice from './institutionSlice';

const rootReducer = combineReducers({
    user: userSlices,
    notification: notificationSlice,
    formdata: formDataSlice,
    reports: reportsSlice,
    reporting: reportingSlice,
    navigation: navigationSlice,
    mfa: mfaSlice,
    aiReports: aiReportsSlice,
    aiReportHistory: aiReportHistorySlice,
    institution: institutionSlice
});

export default rootReducer;